import detailDefault from '../../detailDefault';
export default class detailIF4IF_Licenses extends detailDefault {
    load(sAction, data) {
        // filtroavani fieldu ktere muze videt uzivatel
        // Jen nazev licence, account manager, start date, end date, element key
        const allowedFields = [
            'name',
            'assigned_user_id',
            'assigned_user_name',
            'license_startdate',
            'license_enddate',
            'elements_license_key_c',
            'elements_license_end_date_c',
        ];

        let fields = sAction.dataGet(data.prefix + '/fields');
        if (fields) fields = fields.toJS();
        fields = Object.keys(fields);

        sAction.dsClear();
        fields.forEach((element) => {
            if (!allowedFields.includes(element)) {
                sAction.dsAdd('set', data.prefix + '/fields/' + element + '/def/visible', false);
            }
        });
        sAction.dsProcess();
    }

    update(sAction, data) {

    }
}
